<template>
  <div>
    <div class="profile__important__notification">
      <h4>General notifications <span class="badge bg-light-info">{{ alertsTotal }}</span></h4>
      <div
        v-for="alert in alerts"
        :key="alert.id"
        class="row d-flex align-items-center general__notification mb-1"
      >
        <div class="col-10">
          <small class="badge bg-light-info me-1">{{ alert.date }}</small>
          <span class="text-danger">
            <i data-feather="bell" />
          </span>
          <span
            class="alert-content"
            v-html="linkedText(alert)"
          />
        </div>
        <div class="col-2 text-end">
          <span
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Go to the notification"
            class="me-1"
          >
            <a
              class="btn bg-light-secondary btn-sm"
              @click="$emit('showAlert', alert)"
            >
              <i data-feather="link" />
            </a>
          </span>
          <span
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Go to the notification"
            class="me-1"
          >
            <a
              v-if="alert.targetable_url && alert.targetable"
              class="btn bg-light-secondary btn-sm"
              :href="$router.resolve({name: alert.targetable_url, params: {id: alert.targetable.id} , query: { actAs: $route.query.actAs } }).href"
              target="_target"
            >
              <i data-feather="external-link" />
            </a>
          </span>
          <span
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Archived general notification"
          >
            <a
              class="btn bg-light-secondary btn-sm"
              @click="read(alert)"
            >
              <i data-feather="archive" />
            </a>
          </span>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center mt-1 justify-content-between">
      <Paginator
        :total="alertsTotal"
        :store="'-'"
        @loading="loading = !loading"
      />
      <div>
        <select
          v-model="perPage"
          style="margin-top: -10px;"
          class="form-select"
          @change="setPerPage"
        >
          <option value="15">
            15 items per page
          </option>
          <option value="50">
            50 items per page
          </option>
          <option value="75">
            75 items per page
          </option>
          <option value="10000">
            All items per page
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Paginator from '@/views/back/partials/Paginator.vue'
import { watch } from 'vue';

export default {
  components: {
    Paginator,
  },
  data() {
    return {
      userId: this.$route.params.id,
      loading: true,
      filters: {
        // begin_date: new Date(),
        archived: false,
        type: {
          value: 2,
        },
        // is_read: {
        //   value: false,
        // },
        auto: false,
      },
      perPage: 15,
    }
  },
  computed: {
    ...mapGetters({
      loggedUser: 'auth/admin',
      fields: 'modals/tableSettingsFields',
      alerts: 'alerts/general',
      alertsTotal: 'alerts/generalTotal',
      currentPage: 'pagination/page',
    }),
  },
  async mounted() {
    await this.$store.dispatch('pagination/savePerPage', this.perPage)
    await this.$store.dispatch('alerts/fetchGeneral', this.filters)
    setTimeout(() => {
      feather.replace({
        width: 14,
        height: 14,
      })
    }, 100)
  },
  watch: {
    currentPage() {
      console.log('Page changed, fetching alerts with filters:', this.filters)
      this.$store.dispatch('alerts/fetchGeneral', this.filters)
    },
  },
  methods: {
    async setPerPage(perPage) {
      this.loading = true

      this.$store.dispatch('pagination/clearPage')
      await this.$store.dispatch('pagination/savePerPage', perPage.target.value)
      // await this.$store.dispatch('alerts/fetchGeneral', this.filters)

      this.loading = false
      setTimeout(() => {
        // eslint-disable-next-line no-undef
        feather.replace({
          width: 14,
          height: 14,
        })
      }, 200)
    },
    linkedText(alert) {
      const urlRegex = /((https?:\/\/|www\.)[^\s]+)/g
      if (!alert.message) return ''
      const max = 300
      const text = alert.message
      
      // Find all URL matches with their positions
      const matches = [...text.matchAll(urlRegex)]
      
      // Determine safe truncation point that doesn't break URLs
      let truncateAt = max
      if (text.length > max) {
        for (const match of matches) {
          const urlStart = match.index
          const urlEnd = match.index + match[0].length
          // If truncation point falls within a URL
          if (urlStart < max && max < urlEnd) {
            // Truncate before URL if there's enough text, otherwise after URL
            truncateAt = urlStart > 50 ? urlStart : urlEnd
            break
          }
        }
      }
      
      const truncated = text.length > truncateAt ? text.slice(0, truncateAt) : text
      const replaced = truncated.replace(urlRegex, url => {
        let href = url
        if (!href.startsWith('http')) href = `https://${href}`
        return `<a href="${href}" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline">${url}</a>`
      })
      return replaced + (text.length > truncateAt ? '...' : '')
    },
    async read(alert) {
      this.$store.dispatch('alerts/archive', alert.id)
      this.$store.dispatch('alerts/fetchGeneral', this.filters).then(() => {
        setTimeout(() => {
          feather.replace({
            width: 14,
            height: 14,
          })
        }, 50)
      })
    },
  },
}
</script>
